import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { CallState } from "redmond";
import { IStoreState } from "../../../../../reducers/types";
import {
  schedulePriceQuote,
  setContactInfo,
  scheduleBook,
  setHertzLoyaltyRewardsNumber,
  fetchApplicableTravelWalletItems,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
} from "../../../actions/actions";
import { MobileCarBookWorkflow } from "./component";
import {
  getSelectedDriverAge,
  getIsBookingValid,
  getPollPriceQuoteCallState,
  getPriceQuote,
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
  hasNoUserPassengersSelector,
  getConfirmationDetails,
  getContactPhone,
  getConfirmationEmail,
  getPriceDifferenceAcknowledged,
  getSchedulePriceQuoteCallState,
  getPaymentRequestV2,
  getHertzLoyaltyRewardsNumber,
  getIsHertzProvider,
  getPriceQuoteErrors,
  getConfirmationDetailsError,
  getOffers,
  getErrorTitles,
  getRewardsPaymentAccountReferenceId,
  getIsTravelWalletPaymentOnly,
  getCreditToApply,
  getUseV1PurchaseFlow,
  getIsTravelApp,
  getApplicableCredit,
  getOfferToApply,
  getInsuranceBaseTrackingProperties,
  getFlightInfoFieldSpec,
  getIsFlightInfoValid,
} from "../../../reducer";
import { getCarShopSelectedVehicle } from "../../../../shop/reducer/selectors";
import { fetchTravelWalletCreditHistory } from "../../../../travel-wallet/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  priceQuote: getPriceQuote(state),
  priceQuoteInProgress:
    getSchedulePriceQuoteCallState(state) === CallState.InProcess ||
    getPollPriceQuoteCallState(state) === CallState.InProcess,
  currentSession: getSession(state),
  paymentMethodId: getSelectedPaymentMethodId(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  selectedVehicle: getCarShopSelectedVehicle(state),
  isBookingValid: getIsBookingValid(state),
  hasNoUserPassengers: hasNoUserPassengersSelector(state),
  reservation: getConfirmationDetails(state),
  confirmationEmail: getConfirmationEmail(state),
  confirmationPhoneNumber: getContactPhone(state),
  priceDifferenceAcknowledged: getPriceDifferenceAcknowledged(state),
  driverAge: getSelectedDriverAge(state),
  canBook: !!getPriceQuote(state) && getPaymentRequestV2(state),
  hertzLoyaltyRewardsNumber: getHertzLoyaltyRewardsNumber(state),
  isHertzProvider: getIsHertzProvider(state),
  priceQuoteErrors: getPriceQuoteErrors(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  offers: getOffers(state),
  errorTitles: getErrorTitles(state),
  rewardsPaymentAccountReferenceId: getRewardsPaymentAccountReferenceId(state),
  credit: getApplicableCredit(state),
  isTravelWalletPaymentOnly: getIsTravelWalletPaymentOnly(state),
  creditToApply: getCreditToApply(state),
  useV1PurchaseFlow: getUseV1PurchaseFlow(state),
  isTravelApp: getIsTravelApp(state),
  offerToApply: getOfferToApply(state),
  insuranceBaseTrackingProperties: getInsuranceBaseTrackingProperties(state),
  hasFlightInfoField: getFlightInfoFieldSpec(state) != null,
  isFlightInfoValid: getIsFlightInfoValid(state),
});

const mapDispatchToProps = {
  schedulePriceQuote,
  setContactInfo,
  scheduleBook,
  setHertzLoyaltyRewardsNumber,
  fetchApplicableTravelWalletItems,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
  fetchTravelWalletCreditHistory,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileCarBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileCarBookWorkflow = withRouter(
  connector(MobileCarBookWorkflow),
);
